const Images = {
  logo: require("../assets/images/logo.png"),
};

export default Images;
